<template>
  <div class="about">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('original.languages25')" name="first">
        <User_addsingle />
      </el-tab-pane>

      
      <el-tab-pane :label="$t('original.languages26')" name="second">
        <User_addmore />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import User_addsingle from './User_addsingle'
import User_addmore from './User_addmore'
export default {
  data() {
    return {
      activeName: 'first',
    }
  },
  components: {
    User_addsingle,
    User_addmore,
  },
  methods: {
    handleClick(tab, event) {},
  },
}
</script>
<style scoped>
.about {
  border: 1px solid #e7e7e7;
  min-height: 95%;
  padding: 16px;
  position: relative;
  background-color: #fff;
}
</style>
